export const isRelativeUrl = (url: string): boolean => {
  return /^\/(?!\/)/.test(url); // Just some basic check
};

export const getDomain = (): string => {
  return window.location.host;
};
